import { limitationList } from "@/mocks/comics";

export default function Limitations() {
  return (
    <section className="mx-auto max-w-page px-4 py-14 md:px-6 md:py-20">
      <div className="grid gap-8 lg:grid-cols-2 lg:gap-12 items-center">
        <div>
          <span className="inline-block rounded-full bg-secondary-200 px-4 py-1.5 text-xs font-bold text-foreground-800 md:text-sm">
            免费版限制说明
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl">
            了解限制，心里有数
            <span className="mt-2 block text-primary-600">免费版的小小妥协</span>
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
            免费版之所以能长期免费，是因为它用体验上的一点让步换来了海量内容的完全开放。
            下面这些限制都很容易适应，而你可以随时通过阅读时长解锁更舒适的体验。
          </p>

          <div className="mt-6 flex flex-wrap gap-3">
            <span className="rounded-full bg-accent-100 px-4 py-2 text-xs font-bold text-accent-800 md:text-sm">
              <i className="ri-check-line mr-1"></i> 不影响核心阅读
            </span>
            <span className="rounded-full bg-accent-100 px-4 py-2 text-xs font-bold text-accent-800 md:text-sm">
              <i className="ri-check-line mr-1"></i> 每日奖励可缓解
            </span>
          </div>
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          {limitationList.map((item) => (
            <article
              key={item.title}
              className="rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-secondary-100 text-primary-700">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 text-sm font-bold md:text-base">{item.title}</h3>
              <p className="mt-2 text-xs leading-relaxed text-foreground-700 md:text-sm">
                {item.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}